import cn from 'classnames';
import _ from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import readXlsxFile from 'read-excel-file';
import { uiChangeProvider } from '../../../../../actions/ui';
import Stocks1cApi from '../../../../../API/shipment/stocks1c-api';
import { TYPE_BUTTONS } from '../../../../../constans';
import { showSuccessNotify } from '../../../../../utils/Notiffication';
import { Column, Row, WhiteBlock } from '../../../Blocks';
import { Select } from '../../../Inputs';
import ExportExcelFileButton from '../ExcelExportFile';
import styles from './styles.module.scss';
import Button from '../../Button';
import { Text } from '../../../WrapsStyle';

const ImportExcelNomenclatureButton = ({
  width = 'default',
  height = '36px',
  style,
  onChange = (_) => _,
  redButton = false,
  children,
  sliceLine = 1,
  ...props
}) => {
  const allProviders = useSelector((store) => store.providers);
  const selectProvider = useSelector((store) => store.ui.selectProvider);
  const [providers, setProviders] = useState([]);
  const [provider, changeProvider] = useState({});
  const dispatch = useDispatch();
  const { role } = useSelector((store) => store.user);

  let [excel, setExcel] = useState([]);

  const parseDataUPD = async (files) => {
    let array = [];

    const readFileOne = async (file, i) => {
      return await readXlsxFile(file).then((rows) => {
        let keys = {};
        rows[16].forEach((item, key) => {
          keys[key] = item;
        }); // забираем наименование столбцов с шапки

        const data = rows
          .slice(17)
          .map((d) => {
            const row = {};
            d.forEach((item, key) => {
              row[keys[key]] = item;
            });
            return row;
          })
          .filter((item) => item['1а'] != '#ERROR_undefined' && item['1а'] != 'null' && item['1а'] !== null);

        const true_data = data.map((item) => ({
          Артикул: `${provider.prefix}-${item['А']}`,
          Наименование: item['1а'],
          'Ставка НДС': item['7'],
          'Единица измерения': item['2а'],
          provider_id: provider.id,
        }));

        showSuccessNotify(`Файл ${i + 1} обработан`);

        array.push(...true_data);
        return true_data;
      });
    };

    let files_array = Array.from(files);
    console.log('files', files, Array.from(files));
    for (let i = 0; i < files_array.length; i++) {
      let res = await readFileOne(files_array[i], i);
      array.push(res);
    }

    let new_excel = _.uniqBy([...excel, ...array], 'Артикул').filter((item) => item['Артикул']?.length > 2);
    setExcel(new_excel);
  };

  const parseData = async (files, is_1C_data = false) => {
    let array = [];

    const readFileOne = async (file, i) => {
      return await readXlsxFile(file).then((rows) => {
        let keys = {};
        rows[0].forEach((item, key) => {
          keys[key] = item;
        }); // забираем наименование столбцов с шапки

        console.log(keys);
        const data = rows.slice(1).map((d) => {
          const row = {};
          d.forEach((item, key) => {
            row[keys[key]] = item;
          });
          return row;
        });

        const true_data = data.map((item) => ({
          Артикул: is_1C_data
            ? item['Номенклатура.Артикул'] || item['Артикул']
            : `${provider.prefix}-${item['Номенклатура.Артикул'] || item['Артикул']}`,
          Наименование: item['Номенклатура.Наименование'] || item['Наименование'],
          'Ставка НДС': item['% НДС'] || item['Ставка НДС'],
          'Единица измерения': item['Вид упаковки'] || item['Единица измерения'],
          provider_id: provider.id,
        }));

        showSuccessNotify(`Файл ${i + 1} обработан`);

        array.push(...true_data);
        return true_data;
      });
    };

    let files_array = Array.from(files);
    console.log('files', files, Array.from(files));
    for (let i = 0; i < files_array.length; i++) {
      let res = await readFileOne(files_array[i], i);
      array.push(res);
    }

    let new_excel = _.uniqBy([...excel, ...array], 'Артикул').filter((item) => item['Артикул']?.length > 2);
    setExcel(new_excel);
  };

  const onLoad = async (e) => {
    let files = e.target.files;

    console.log(files);
    parseDataUPD(files);
    e.target.value = null;
  };

  const onLoadFile = async (e, is_1c_data) => {
    let files = e.target.files;

    parseData(files, is_1c_data);
    e.target.value = null;
  };

  const calcDownloadedData = useCallback(() => {
    return excel;
  }, [excel]);

  console.log(provider);

  // список поставщиков
  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders(p);
    }
  }, [allProviders]);

  useEffect(() => {
    if (selectProvider) {
      changeProvider(selectProvider);

      const provider_data = providers.find((item) => selectProvider.id === item.id);
      if (provider_data) {
        changeProvider(provider_data); // прогрузка времени обновления остатка
      }
    } else {
      const p = allProviders.filter((item) => item.is_stock);
      changeProvider(p[0] || {});
    }
  }, [selectProvider, providers]);

  const isAdmin = role === 'owner' || role === 'admin';
  console.log('1', excel);
  return (
    <Column>
      <WhiteBlock>
        <Select
          width={'200px'}
          label="Поставщик"
          select={provider}
          valueFn={(p) => p?.name}
          list={providers}
          onSelect={(v) => dispatch(uiChangeProvider(v))}
        />

        <Row style={{ marginTop: '15px' }}>
          <label style={{ width, height, ...style }}>
            <span className={cn(styles.button_base, styles.button_blue, redButton && styles.button_red, props.styles)}>
              Загрузить файлы упд
            </span>
            <input type="file" className={styles.input} onChange={(e) => onLoad(e)} multiple />
          </label>

          <div style={{ marginLeft: '10px' }}>
            <label style={{ width, height, ...style }}>
              <span
                className={cn(styles.button_base, styles.button_blue, redButton && styles.button_red, props.styles)}
              >
                Загрузить номенклатуру
              </span>
              <input type="file" className={styles.input} onChange={(e) => onLoadFile(e)} multiple />
            </label>
          </div>

          {isAdmin && (
            <div style={{ marginLeft: '10px' }}>
              <label style={{ width, height, ...style }}>
                <span
                  className={cn(styles.button_base, styles.button_blue, redButton && styles.button_red, props.styles)}
                >
                  Загрузить файл c 1c
                </span>
                <input type="file" className={styles.input} onChange={(e) => onLoadFile(e, true)} multiple />
              </label>
            </div>
          )}

          <ExportExcelFileButton
            style={{ marginLeft: '15px' }}
            filename={`Номенклатруа ${provider?.name} ${excel.length}`}
            data={{
              'Заказ общий': calcDownloadedData(),
            }}
            buttonTitle={`Скачать номенклатуру`}
          />

          <Button
            type={TYPE_BUTTONS.WHITE}
            onClick={() =>
              Stocks1cApi.xmlUPD({ data: { inputRows: excel } })
            }
            style={{ marginLeft: '10px', background: 'rgb(250 255 42 / 58%)' }}
          >
            Выгрузка в xml
          </Button>
          <Button type={TYPE_BUTTONS.RED} style={{ marginLeft: '15px' }} onClick={() => setExcel([])}>
            Очистить
          </Button>
        </Row>

        <Text style={{ marginTop: '15px' }}>{`Обработанно: ${excel.length}`}</Text>
      </WhiteBlock>
    </Column >
  );
};

export default ImportExcelNomenclatureButton;
